import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownToLine } from "@awesome.me/kit-cae4660dd3/icons/classic/solid";
import { Resource } from "./lesson-information-modal-types";
import "./resources.scss";

interface IResourcesProps {
  resources: Resource[];
  lessonType: string;
  tier1ResourceToken: string;
}

const Resources = (props: IResourcesProps) => {
  const { resources, lessonType, tier1ResourceToken } = props;

  const getResourceURL = (resource: Resource) => {
    return lessonType === "Tier1" ? `${resource.src}?access_token=${tier1ResourceToken}` : resource.src;
  };

  const download = (resource: Resource) => {
    fetch(getResourceURL(resource))
      .then((response) => response.blob())
      .then((blob) => {
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobURL;
        a.style.display = "none";
        a.download = resource.title;
        a.setAttribute("data-testid", "resource-download-link");
        document.body.appendChild(a);
        a.click();
      });
  };

  return (
    <div className="resources-container">
      <div className="resources-title">Resources</div>
      {resources?.length > 0 ? (
        <div className="resources-list">
          {resources.map((item) => {
            return (
              <div className="resource-item" key={item.src}>
                <a target="_blank" href={getResourceURL(item)} className="link">
                  {item.title}
                </a>
                <FontAwesomeIcon
                  icon={faArrowDownToLine}
                  onClick={() => download(item)}
                  className="download"
                  data-testid="resource-download-icon"
                />
              </div>
            );
          })}
        </div>
      ) : (
        <div className="resources-empty">Resources are unavailable at this time.</div>
      )}
    </div>
  );
};

export default Resources;
